/**
 * FAQs for /compare/jev-vs-all, exported separately so routes.tsx can build the FAQPage JSON-LD without
 * pulling the page chunk (and its benchmark export) into the route table. No figures here: every number on
 * the page comes from src/data/jev-vs-all/jev-vs-all.v1.json through the page's data.ts, and the answers
 * stay true across releases. The latency answer names the GPU tiers; the page test checks them against the
 * export.
 */
export const jevVsAllFaq: { q: string; a: string }[] = [
  {
    q: 'Why does LangWatch benchmark the model its own product runs on?',
    a: 'Instant Evals runs on Jev, so we wanted to know how far open models are from it before recommending either. We made real judgment calls along the way (the contamination rule, the framings, the decision thresholds, which caveats to show), and every one of them is written down on this page so you can check it. What we did not touch by hand is the ranking itself: the tie test decides who is ahead.',
  },
  {
    q: 'Which model is the winner?',
    a: 'On each task the tie test decides: one side is ahead, or they are tied when the data cannot separate them. Grayed rows were trained on the task’s data; they are shown for reference and never counted.',
  },
  {
    q: 'What does a grayed row mean?',
    a: 'The model was trained on the test items or on another split of the same dataset, so its score measures memory of that dataset more than the skill. The contamination audit graded every model and task pair; the rule and the evidence are in the method section.',
  },
  {
    q: 'Why is a model with no declared training data never grayed?',
    a: 'Models are marked on what their authors disclosed. A model that declares nothing has nothing to mark, and that is not proof it never saw the data.',
  },
  {
    q: 'Why are some sources left out of the published numbers?',
    a: 'Two sources are licensed for non-commercial use only, so the moderation and RAG numbers here are recomputed without them. Internal test sets are not shown at all. The audit also names sources that a trivial classifier solves; those stay in the headline, with the number without them next to it.',
  },
  {
    q: 'Is the latency comparable between the hosted model and the open ones?',
    a: 'Only on the same GPU. Open models ran on a laptop GPU, an L4 or an H100, and each latency names its GPU. Jev’s includes the network round trip to its API.',
  },
  {
    q: 'Can I run the same judges on my own data?',
    a: 'Partly. Instant Evals runs the same hosted Jev judge over your own production history from the LangWatch CLI, so that half is the same judge. The open models are published weights you can serve yourself, but not with this benchmark’s exact setup: the harness, the framings and the decision thresholds used here are not public yet.',
  },
]
